// extracted by mini-css-extract-plugin
module.exports = {"CardGrid":"MoreProducts_CardGrid__1J4xM","CardGridWrapper":"MoreProducts_CardGridWrapper__2svli","CardColumnTitle":"MoreProducts_CardColumnTitle__Dz1S5"};